import React, { useState, useEffect } from "react";
import LeaveTypeService from "../../services/LeaveTypeService";
import { Button } from "@material-ui/core";
import { CreateTwoTone, DeleteOutlineRounded } from "@material-ui/icons";
import { userDetailContext } from "../../App";
import { useContext } from "react";
import ConfirmationDialog from "../tools/ConfirmationDialog";
import Message from "../tools/Message";
import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";
import { DataGrid } from '@material-ui/data-grid';
import { makeStyles } from "@material-ui/core/styles";
import Title from "../../components/Title";
import Spacer from "../../components/Spacer";
import { useNavigate } from 'react-router-dom';
const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));
function LeaveTypeTable() {
  const navigate = useNavigate();
  const [id_to_delete, setId_to_delete] = useState(0);
  const [confirmationDialog, setConfirmationDialog] = React.useState({
    openDialog: false,
    messageDialog: 'Voulez vous vraiment supprimer  ?',
  });
  const { openDialog, messageDialog } = confirmationDialog;
  const [message, setMessage] = React.useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;

  //Samuela: paramètrage pour le loader
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);

  const contextData = useContext(userDetailContext);
  const classes = useStyles();

  function loadTable() {
    setOpenLoadingSimpleBackdrop(true);
    LeaveTypeService.getLeaveType().then((result) => {
      if (result && result.data) {
        setRows(result.data.map((row) => ({ ...row, id: row.leave_type_id })));
        setOpenLoadingSimpleBackdrop(false);
      }
      else {
        setOpenLoadingSimpleBackdrop(false);
      }
    });
  }
  const handleDelete = (id) => (ev) => {
    setId_to_delete(id);
    setConfirmationDialog({ ...confirmationDialog, openDialog: true });
  };
  function closeDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }
  function confirmDialog() {

    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
    setOpenLoadingSimpleBackdrop(true);
    LeaveTypeService.deleteLeaveType(id_to_delete).then((result) => {
      if (result && result.status) {
        loadTable();
      }
    }).catch((err) => {
      setMessage({ ...message, open: true, color: 'red', messageInfo: 'erreur' });
      setOpenLoadingSimpleBackdrop(false);
    });
  }
  function cancelDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }
  const handleEdit = (id) => (ev) => {
    navigate("/leave_type/add/" + id);
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Nom',
      width: 200,
    },
    {
      field: 'desc',
      headerName: 'Description',
      width: 300,
    }, {
      field: 'leave_count_factor',
      headerName: 'Facteur de comptage',
      width: 250,
    },
    {
      field: 'leave_type_date',
      headerName: 'Jour de comptage',
      width: 250,
      valueFormatter: (params) => {
        return `${params.row.leave_type_date} du mois`;
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      disableClickEventBulbing: true,
      renderCell: (params) => {
        return (
          <div>
            <Button onClick={handleEdit(params.id)} title="Modifier "><CreateTwoTone style={{ color: "black" }} />
            </Button>
            <Button onClick={handleDelete(params.id)} title="Supprimer">
              <DeleteOutlineRounded style={{ color: "red" }} />
            </Button>
          </div>
        );
      },
      width: 200,
    },
  ];

  const [data, setData] = React.useState([]);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    loadTable();
  }, []);
  return (
    <React.Fragment>
      <ConfirmationDialog openDialog={openDialog} messageDialog={messageDialog} closeDialog={closeDialog} confirmDialog={confirmDialog} cancelDialog={cancelDialog} />
      <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      <Title>Listes des facteurs de comptage</Title>
      <Spacer y={2} />
      <div style={{ height: "70vh", width: '100%' }} className={classes.root} >
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          disableSelectionOnClick
        />
      </div>
    </React.Fragment>
  );
}
export default LeaveTypeTable